/* Collection product-type filter.
   The grid paginates at 11 with infinite scroll and collections reach 149 products,
   so filtering only what is in the DOM would silently return a partial answer. On the
   first filter interaction we harvest every remaining page, then filter the full set.
   State lives in the URL (?type=Hoodies) so it is shareable and survives back/forward. */
(function () {
  var row = document.querySelector('[data-pc-filters]');
  var grid = document.getElementById('product-grid');
  if (!row || !grid) return;

  var ALL = null;              // full card list once harvested
  var origHTML = grid.innerHTML;
  var countEl = document.querySelector('[data-pc-total]');

  function cards(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-pc-type-holder]'));
  }

  function setCount(n) {
    document.querySelectorAll('[data-pc-total]').forEach(function (el) {
      el.textContent = String(n);
    });
  }

  function pagesNeeded() {
    var total = parseInt(row.getAttribute('data-pc-collection-count') || '0', 10);
    var per = parseInt(row.getAttribute('data-pc-per-page') || '0', 10);
    if (!total || !per) return 1;
    return Math.ceil(total / per);
  }

  function harvest() {
    if (ALL) return Promise.resolve(ALL);
    var n = pagesNeeded();
    var here = cards(grid);
    if (n <= 1) { ALL = here; return Promise.resolve(ALL); }
    row.setAttribute('data-busy', '1');
    var base = window.location.pathname;
    var jobs = [];
    for (var i = 2; i <= n; i++) jobs.push(fetch(base + '?page=' + i, { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
    return Promise.all(jobs).then(function (htmls) {
      var out = here.slice();
      htmls.forEach(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = doc.getElementById('product-grid');
        if (g) cards(g).forEach(function (c) { out.push(document.importNode(c, true)); });
      });
      ALL = out;
      row.removeAttribute('data-busy');
      return ALL;
    }).catch(function () {
      row.removeAttribute('data-busy');
      ALL = here;   // degrade to what we have rather than hang
      return ALL;
    });
  }

  function apply(type, push) {
    Array.prototype.forEach.call(row.querySelectorAll('.pc-filter'), function (b) {
      var on = (b.getAttribute('data-pc-filter') || '') === (type || '');
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (!type) {
      grid.innerHTML = origHTML;
      setCount(parseInt(row.getAttribute('data-pc-collection-count') || '0', 10));
      if (push) history.pushState({ t: '' }, '', window.location.pathname);
      return;
    }

    harvest().then(function (all) {
      var keep = all.filter(function (c) { return (c.getAttribute('data-pc-type') || '') === type; });
      grid.innerHTML = '';
      keep.forEach(function (c) { grid.appendChild(c.cloneNode(true)); });
      setCount(keep.length);
      if (push) {
        var u = window.location.pathname + '?type=' + encodeURIComponent(type);
        history.pushState({ t: type }, '', u);
      }
    });
  }

  row.addEventListener('click', function (e) {
    var b = e.target.closest('.pc-filter');
    if (!b) return;
    e.preventDefault();
    apply(b.getAttribute('data-pc-filter') || '', true);
  });

  window.addEventListener('popstate', function () {
    var p = new URLSearchParams(window.location.search);
    apply(p.get('type') || '', false);
  });

  var initial = new URLSearchParams(window.location.search).get('type');
  if (initial) apply(initial, false);
})();
